export const ProtocolDeviationDescription = () => {
  return (
    <>
      Protocol Deviations created for specified studies, sites across a time period
      <br />
      <strong>Note:</strong> Dashboard data is refreshed nightly to ensure you’re viewing the most up-to-date
      information available
    </>
  );
};
